import { FiscalEventStatus } from '../../types/fiscal/FiscalEvent';

const labels: Record<FiscalEventStatus, string> = {
  DRAFT: 'Borrador', VALIDATED: 'Validado', SIGNED: 'Firmado, pendiente de transmisión',
  SENDING: 'Transmitiendo', PROCESSED: 'Procesado', REJECTED: 'Rechazado',
  UNKNOWN: 'Estado desconocido', INVALIDATED: 'Evento invalidado',
};
const colors: Record<FiscalEventStatus, string> = {
  DRAFT: 'bg-slate-100 text-slate-700', VALIDATED: 'bg-blue-100 text-blue-700',
  SIGNED: 'bg-amber-100 text-amber-800', SENDING: 'bg-blue-100 text-blue-700',
  PROCESSED: 'bg-green-100 text-green-700', REJECTED: 'bg-red-100 text-red-700',
  UNKNOWN: 'bg-orange-100 text-orange-800', INVALIDATED: 'bg-gray-200 text-gray-700',
};

export default function FiscalEventStatusBadge({ status }: { status: FiscalEventStatus }) {
  return <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${colors[status]}`}>
    {status === 'SENDING' && <span className="mr-2 animate-pulse">•</span>}{labels[status]}
  </span>;
}
